/**
 * useCapabilities — reads the authoritative capability map that the server
 * sent at login (via GET /api/auth/me) and stored in localStorage.userData.
 *
 * Usage:
 *   const { canImportData, canEditScores } = useCapabilities();
 *   if (canImportData) { ... }
 *
 * Falls back to false for any capability not present (safe default for new caps).
 * Never derive capabilities from role strings in the client — use this hook instead.
 */
export function useCapabilities() {
    try {
        const userData = JSON.parse(localStorage.getItem('userData') || '{}');
        const caps = { ...(userData.capabilities || {}) };
        if (caps.canViewSchedule === undefined) caps.canViewSchedule = ['teacher', 'manager', 'headmaster', 'admin'].includes(userData.role);
        if (caps.canManageSchedule === undefined) caps.canManageSchedule = ['manager', 'headmaster', 'admin'].includes(userData.role);
        return caps;
    } catch (_) {
        return {};
    }
}
